import { Game } from "@lobby/core/src/entities/game";

export function useHeaderCategories() {
  const { data: categoriesList } = Game.useCategoriesList();
  return categoriesList?.filter(({ tag }) => tag === "header") || [];
}
